import { Box, Grid, Switch } from "@mui/material";
import MTable, { MTableAction } from "material-table";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import { useState } from "react";
import { GetReportRecruiterAction, GetWorkLoadAction } from "../../../../../store/ATS/Report/Action";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getEmployeeId, getUserData } from "../../../Base/helper/baseFunctions";
import CustomPagination from "../../../Base/views/CustomPagination";
const WorkloadReports = () => {
    const user = getUserData();
    const dispatch = useDispatch();
    const isGroupOrgFlowTrue = user?.grouporg_flow === true;
    const [userData, setUserData] = useState({ load: true, values: [] })
    const [selectedRows, setSelectedRows] = useState([]);
    const [filters, setFilters] = useState({ primary_recruiter_filter: "" });
    const { atsWorkLoadData, isLoading } = useSelector(state => state.AtsReducer?.AtsReportReducer);
    const parseAndSum = (field) => atsWorkLoadData?.reduce((acc, curr) => acc + parseInt(curr[field] || '0', 10), 0);
    const sumno_of_jobs = parseAndSum('no_of_jobs');
    const sumno_of_positions = parseAndSum('no_of_positions');
    const hasNonZeroSum = sumno_of_jobs || sumno_of_positions
    const displayableKeys = hasNonZeroSum ? [
        ["Number of Jobs", sumno_of_jobs],
        ["Number of Position", sumno_of_positions],
    ] : [];
    const [allRecruiter, setAllRecruiter] = useState(true);
    const [atsRecruiterData, setAtsRecruiterData] = useState([]);
    const [recruiterReady, setRecruiterReady] = useState(false);

    useEffect(() => {
        if (!recruiterReady) return;
        dispatch(GetWorkLoadAction({
            from_date: null,
            to_date: null,
            primary_recruiter: filters?.primary_recruiter_filter ? `{${filters?.primary_recruiter_filter?.map((item) => item.ats_users_id).join(",")}}` : null,
        }))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters])
     useEffect(()=> {
        const login_employee_id = allRecruiter ? null : getEmployeeId();
        dispatch(GetReportRecruiterAction({login_employee_id}, (resp) => {
            setUserData({ load: false, values: [] })
            setAtsRecruiterData(resp?.data?.data);
            if(allRecruiter) {
                setFilters((prev) => {return {...prev, primary_recruiter_filter: ""}})
            } else {
                setFilters((prev) => {return {...prev, primary_recruiter_filter: resp?.data?.data}})
            }
            setRecruiterReady(true); 
        }));
    },[allRecruiter, dispatch])
    const handleFilter = (event, value) => {
        if (["primary_recruiter_filter"].includes(event)) {
            if (value) setFilters({ ...filters, [event]: value })
            else setFilters({ ...filters, [event]: "" })
        }
    }
    const handleExportSelected = () => {
        const headers = [
            { label: "Recruiter", key: "recruiter_name" },
            { label: isGroupOrgFlowTrue ? "Group Org" : "Client", key: "company_name" },
            { label: "Number of Jobs", key: "no_of_jobs" },
            { label: "Number of Position", key: "no_of_positions" }
        ];

        const csvData = [headers.map(header => header.label)];
        selectedRows.forEach(row => {
            const rowData = headers.map(header => row[header.key]);
            csvData.push(rowData);
        });
        const csv = csvData.map(row => row.join(",")).join("\n");
        const blob = new Blob([csv], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const downloadLink = document.createElement("a");
        downloadLink.href = url;
        downloadLink.download = "WorkLoad.csv";
        downloadLink.setAttribute("target", "_blank");
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(url);
    };
    return (
        <>
            <Box sx={{ mt: 1 }}>
                <Grid container columnSpacing={1} mb={1}>
                    <Grid key="primary_recruiter_id" item xs={12} sm={4}>
                        <SelectableSearch
                            isOptionEqualToValue={(option, value) =>
                                +option.ats_users_id === +value.ats_users_id
                            }
                            limitTags={2}
                            label={allRecruiter ? "All Recruiter" : "My Recruiter"}
                            multiple={true}
                            value={filters.primary_recruiter_filter}
                            loading={() => setUserData({ load: false, values: atsRecruiterData })}
                            fieldLabel="first_name"
                            required={false}
                            grouping={true}
                            variant={"outlined"}
                            name="primary_recruiter_filter"
                            onChangeEvent={handleFilter}
                            data={userData}
                            size="small"
                        />
                    </Grid>
                </Grid>
            </Box>
            <Box>
                <MTable
                    isLoading={isLoading}
                    columns={[
                        { title: "Recruiter", cellStyle: { padding: "10px", textAlign: "left" }, headerStyle: { padding: "10px", textAlign: "left" }, field: "recruiter_name", editable: "never" },
                        { title: isGroupOrgFlowTrue ? "Group Org" : "Client", cellStyle: { padding: "10px", textAlign: "left" }, headerStyle: { padding: "10px", textAlign: "left" }, field: "company_name", editable: "never" },
                        { title: "Number of Jobs", cellStyle: { padding: "10px", textAlign: "center" }, headerStyle: { padding: "10px", textAlign: "center" }, field: "no_of_jobs", editable: "never" },
                        { title: "Number of Position", cellStyle: { padding: "10px", textAlign: "center" }, headerStyle: { padding: "10px", textAlign: "center" }, field: "no_of_positions", editable: "never" },
                    ]}

                    data={atsWorkLoadData || []}
                    options={{
                        maxBodyHeight: "54vh",
                        minBodyHeight: "54vh",
                        sorting: true,
                        search: true,
                        searchFieldAlignment: "right",
                        searchAutoFocus: true,
                        searchFieldVariant: "standard",
                        filtering: false,
                        exportButton: false,
                        exportAllData: true,
                        paging: true,
                        pageSizeOptions: [25, 50],
                        pageSize: 25,
                        showTextRowsSelected: true,
                        selectionProps: rowData => ({
                            disabled: [null, '', 0, '0'].includes(rowData.commission_percentage),
                        }),
                        showSelectAllCheckbox: true,
                        selection: true,
                        actionsColumnIndex: -1,
                        grouping: false,
                        addRowPosition: "first",
                        columnsButton: false,
                        draggable: false
                    }}
                    actions={[
                        {
                            icon: () => 
                                <Box
                                id="filters"
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: 0.3,
                                    px: 1,
                                }}
                                >
                                <Box sx={{ fontSize: "12px", fontWeight: 500 }}>
                                    My Reportees
                                </Box>

                                <Switch
                                    checked={!allRecruiter}
                                    onChange={(e) => setAllRecruiter(!e.target.checked)}
                                    size="small"
                                />
                                </Box>,
                            isFreeAction: true,
                        },
                        {
                            icon: () => <CloudDownloadIcon />,
                            tooltip: 'Export Selected Rows',
                            onClick: () => handleExportSelected(),
                            hidden: selectedRows.length === 0,
                        },
                    ]}
                    components={{
                        Pagination: props => <CustomPagination {...props} displayableKeys={displayableKeys} />,
                        Action: (props) => {
                            const ActionComponent = props?.components?.Action || MTableAction;
                            if (props?.action?.icon && typeof props?.action?.icon === "function") {
                            const IconElement = props?.action?.icon();
                            // Check if the rendered element is CustomToggle
                            if (IconElement?.props?.id === "filters") {
                                return (
                                <Box
                                    sx={{
                                        "& .MuiIconButton-root": {
                                            background: "transparent !important",
                                            boxShadow: "none !important",
                                            padding: "0px !important",
                                            margin: "0px !important",
                                            borderRadius: "0px !important",
                                            "&:hover": {
                                            background: "transparent !important",
                                            },
                                        },
                                        "& .MuiTouchRipple-root": {
                                            display: "none",
                                        },
                                    }}
                                >
                                    <ActionComponent {...props} />
                                </Box>
                                );
                            }
                            }
                            return <ActionComponent {...props} />;
                        },
                    }}
                    onSelectionChange={(rows) => setSelectedRows(rows)}
                    title="WorkLoad"
                />
            </Box>
        </>
    )
}

export default WorkloadReports;